/* eslint-disable no-control-regex */

export const colorReplacements: [RegExp, string][] = [
  [/\u001b[\n]?\[[\n]?0[\n]?m/g, '</span>'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?1[\n]?m/g, '<span class="log-color-red">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?2[\n]?m/g, '<span class="log-color-green">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?3[\n]?m/g, '<span class="log-color-yellow">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?4[\n]?m/g, '<span class="log-color-blue">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?5[\n]?m/g, '<span class="log-color-purple">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?6[\n]?m/g, '<span class="log-color-cyan">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?7[\n]?m/g, '<span class="log-color-neutral">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?0[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-neutral">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?1[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-red">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?2[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-green">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?3[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-yellow">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?4[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-blue">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?5[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-purple">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?6[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-cyan">'],
  [/\u001b[\n]?\[[\n]?(?:0[\n]?;[\n]?1[\n]?;[\n]?)?3[\n]?7[\n]?;[\n]?1[\n]?m/g, '<span class="log-color-neutral">'],
];

const htmlEntities: Record<string, string> = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const sanitize = (message: string) => message.replace(/[<>"']/g, (character) => htmlEntities[character]);

const replaceColors = (message: string, replaceWithHTML = true) => {
  let formattedMessage = message;
  colorReplacements.forEach(([regex, htmlElement]) => {
    formattedMessage = formattedMessage.replace(regex, replaceWithHTML ? htmlElement : '');
  });

  // Remove any remaining ANSI codes
  formattedMessage = formattedMessage.replace(
    /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g,
    '',
  );

  return formattedMessage;
};

const notAQuoteEntity = '(?!&(?:quot|#39);)';
const urlPattern = new RegExp(
  `(https?://[^\\s$.?#-]${notAQuoteEntity}.(?:${notAQuoteEntity}[^\\s\\][^"'><}{])*${notAQuoteEntity}[^\\s\\][^"'><)(}{?.,;!])`,
  'g',
);

const linkify = (message: string) =>
  message.replace(
    urlPattern,
    "<a href='$1' target='_blank' rel='noopener noreferrer' class='buildLog__external-link'>$1</a>",
  );

const breakLines = (message: string) => {
  const messageWithoutLastLineBreak = message.replace(/\n$/g, '');
  return `<div class="buildLog__line">${messageWithoutLastLineBreak.replace(
    /\n/g,
    '</div><div class="buildLog__line">',
  )}</div>`;
};

export const formatBuildLog = (message: string, { useDivsPerLine = true, replaceColorsWithHTML = true } = {}) => {
  let formattedMessage = message;

  formattedMessage = sanitize(formattedMessage);
  formattedMessage = replaceColors(formattedMessage, replaceColorsWithHTML);
  formattedMessage = linkify(formattedMessage);
  if (useDivsPerLine) formattedMessage = breakLines(formattedMessage);

  return formattedMessage;
};
